<template>
  <div class="changelog-modal">
    <div class="changelog-content">
      <h2>Changelog</h2>
      <button class="modal__close" @click="close">
        <i class="far fa-times-circle"></i>
      </button>
      
      <div class="changelog-entries">
        <div class="changelog-entry" v-for="(entry, index) in changelogEntries" :key="index">
          <div class="entry-header">
            <h3 class="entry-date">{{ entry.date }}</h3>
          </div>
          <ul class="entry-items">
            <li v-for="(item, itemIndex) in entry.items" :key="itemIndex">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangelogModal',
  data() {
    return {
      changelogEntries: [
        {
          date: 'V: 4.0',
          items: [
            'Added click licensing + recaptcha',
            'Changed background colour for download button',
            'Added option to search for reference number on home page.',
            'Added Root curvature calculator',
            'Added referral system',
            'Added PDF export.',
            'Changed E-Learning Course / E-CAT Demo labels',
            'Added dashboard to navigate between E-CAT and R-CAT'
          ]
        },
        {
          date: 'V: 3.3',
          items: [
            'Changed E-CAT score calculation',
          ]
        },
        {
          date: 'V: 3.2',
          items: [
            'Added popup for user when clicking back on assessment to warn them about of loss of data.',
            'Changed \'in association with\' to \'partially funded by\'',
          ]
        },
        {
          date: 'V: 3.1',
          items: [
            'Changed \'Real Patient\' to \'Patient\' and \'Simulated Patient\' to \'Simulated\'',
            'Added ESO logo and hyperlink to the main page.',
            'Added & Hosted E-Learning Tool'
          ]
        },
        {
          date: 'V: 3.0',
          items: [
            'Initial release',
          ]
        }
      ]
    };
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.changelog-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.changelog-content {
  position: relative;
  background-color: white;
  border-radius: 5px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  padding: 20px;
  overflow-y: auto;

  h2 {
    margin-top: 0;
    color: #013B82;
    margin-bottom: 20px;
  }
  
  .modal__close {
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: 0;
    font-size: 32px;
    cursor: pointer;
    color: #666;
    
    &:hover {
      color: #013B82;
    }
  }
}

.changelog-entries {
  .changelog-entry {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    text-align: left;
    
    &:last-child {
      border-bottom: none;
    }
    
    .entry-header {
      margin-bottom: 10px;
      
      .entry-date {
        color: #013B82;
        font-size: 18px;
        margin: 0;
      }
    }
    
    .entry-items {
      margin: 0;
      padding-left: 20px;
      
      li {
        margin-bottom: 8px;
        line-height: 1.5;
      }
    }
  }
}
</style>